module.exports = __webpack_public_path__ + "static/media/img-profile-default-80.ba1567f9.svg";